import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// Vue CLI 无需额外导入样式，直接创建 app
const app = createApp(App);
app.use(router);
app.mount('#app');